import React from 'react';
import { styled, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { useLaptop } from 'hooks';
import { MetaLayout } from 'components';
import { useTranslation } from 'next-i18next';
import { getTranslations } from '../utils/i18n-cache';

const PrivacyPolicyPage = () => {
  const { isOverLaptop } = useLaptop();
  const { t } = useTranslation();
  return (
    <MetaLayout title={t`app.privacy_policy`}>
      <Box>
        <Content>
          <Typography variant={isOverLaptop ? 'big500' : 'big700'} as={'p'}>
            Privacy Policy
          </Typography>
          <Typography
            as={'p'}
            variant={isOverLaptop ? 'average400' : 'average200'}
            mb={2}
          >
            Information you provide to us: You may provide information by
            filling in forms on our website or by corresponding with us by
            phone, email, or otherwise. This includes information you provide
            when you register to use our website, purchase gift cards or
            vouchers, or report a problem with our website. Technical
            information: We automatically collect information about your visit
            to our website, including, but not limited to, traffic data,
            location data, logs, the resources that you access, and other
            communication data.
          </Typography>
          <Typography variant={isOverLaptop ? 'big500' : 'big700'} as={'p'}>
            How we use your information
          </Typography>
          <Typography
            as={'p'}
            variant={isOverLaptop ? 'average400' : 'average200'}
            mb={2}
          >
            We use the information we collect to provide, maintain, protect, and
            improve our services, to develop new ones, and to protect ourselves
            and our users. We also use this information to provide information
            about other goods and services we offer that are similar to those
            you have already purchased or enquired about.
          </Typography>
          <Typography variant={isOverLaptop ? 'big500' : 'big700'} as={'p'}>
            Disclosure of Your Information
          </Typography>
          <Typography
            as={'p'}
            variant={isOverLaptop ? 'average400' : 'average200'}
            mb={2}
          >
            We will not sell, distribute, or lease your personal information to
            third parties unless we have your permission or are legally
            required. We may use your personal information to send you
            promotional information about third parties that interest you.
          </Typography>
          <Typography variant={isOverLaptop ? 'big500' : 'big700'} as={'p'}>
            Cookies
          </Typography>
          <Typography
            as={'p'}
            variant={isOverLaptop ? 'average400' : 'average200'}
            mb={2}
          >
            Our website uses cookies to distinguish you from other users. This
            helps us to provide you with a good experience when you browse our
            website and also allows us to improve our site.
          </Typography>
          <Typography variant={isOverLaptop ? 'big500' : 'big700'} as={'p'}>
            Storage and Security of Personal Data
          </Typography>
          <Typography
            as={'p'}
            variant={isOverLaptop ? 'average400' : 'average200'}
            mb={2}
          >
            The security of your data is critical to us. We will use appropriate
            physical, technical, and administrative safeguards to protect your
            data from unauthorized access and disclosure.
          </Typography>
          <Typography variant={isOverLaptop ? 'big500' : 'big700'} as={'p'}>
            Your Rights
          </Typography>
          <Typography
            as={'p'}
            variant={isOverLaptop ? 'average400' : 'average200'}
            mb={2}
          >
            You have the right to access the information we hold about you and
            to ask that your personal information be corrected, updated, or
            deleted.
          </Typography>
          <Typography variant={isOverLaptop ? 'big500' : 'big700'} as={'p'}>
            Changes to our Privacy Policy
          </Typography>
          <Typography
            as={'p'}
            variant={isOverLaptop ? 'average400' : 'average200'}
            mb={2}
          >
            Any changes we make to our privacy policy in the future will be
            posted on this page. Please check back frequently to see any updates
            or changes.
          </Typography>
          <Typography variant={isOverLaptop ? 'big500' : 'big700'} as={'p'}>
            Contact Us
          </Typography>
          <Typography
            as={'p'}
            variant={isOverLaptop ? 'average400' : 'average200'}
            mb={2}
          >
            If you have any questions about this privacy policy, please get in
            touch with us at help@shifa.one.
          </Typography>
        </Content>
      </Box>
    </MetaLayout>
  );
};

export default PrivacyPolicyPage;

export const Content = styled(Box)(({ theme }) => ({
  padding: '60px 0 80px 0',
  [theme.breakpoints.down('laptop')]: {
    padding: '24px 0 40px 0',
  },
}));

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await getTranslations(locale ?? 'en')),
  },
});
